// <s-drag-scroll> — lets mouse users drag a horizontal scroll-snap track and step it with prev/next commands.
class SDragScroll extends HTMLElement {
  #controller;
  #track;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#track = this.querySelector('[data-track]');
    if (!this.#track) return;

    let startX = 0;
    let startScroll = 0;
    let dragging = false;
    let moved = false;

    this.#track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = this.#track.scrollLeft;
      this.#track.dataset.dragging = '';
    }, { signal });

    this.#track.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      this.#track.scrollLeft = startScroll - delta;
    }, { signal });

    const stop = () => {
      dragging = false;
      delete this.#track.dataset.dragging;
    };
    window.addEventListener('pointerup', stop, { signal });
    this.#track.addEventListener('pointerleave', stop, { signal });

    // A drag must not also follow the link under the pointer.
    this.#track.addEventListener('click', (event) => {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }, { capture: true, signal });

    this.#track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });

    this.addEventListener('command', (event) => {
      const direction = event.command === '--next' ? 1 : event.command === '--prev' ? -1 : 0;
      if (!direction) return;
      const slide = this.#track.firstElementChild;
      const step = slide ? slide.getBoundingClientRect().width + 16 : this.#track.clientWidth * 0.8;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const dir = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      this.#track.scrollBy({ left: step * direction * dir, behavior: reduce ? 'auto' : 'smooth' });
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

customElements.define('s-drag-scroll', SDragScroll);
